import React from "react";

function License() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 512.022 512.022"
      className="size-6"
      stroke="currentColor"
    >
      <g>
        <path
          d="M396.011 213.044V34.745C396.011 15.586 380.424 0 361.265 0H78.756C59.597 0 44.011 15.586 44.011 34.745v370.51c0 19.159 15.586 34.745 34.745 34.745h213.255v56c0 12.236 13.25 19.998 23.938 13.892l48.062-27.464c53.084 30.334 50.309 29.572 56 29.572 8.836 0 16-7.174 16-16V386.974c56.948-54.71 34.391-149.816-40-173.93zM78.756 408a2.748 2.748 0 0 1-2.745-2.745V34.745A2.748 2.748 0 0 1 78.756 32h282.51a2.748 2.748 0 0 1 2.745 2.745V208c-57.346 0-104 46.654-104 104 0 29.428 12.288 56.037 32 74.974V408zm325.255 60.429-32.062-18.321a16 16 0 0 0-15.877 0l-32.062 18.321v-60.434c25.513 10.671 54.453 10.685 80 0v60.434zm-40-84.429c-39.701 0-72-32.299-72-72s32.299-72 72-72 72 32.299 72 72-32.299 72-72 72z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"    
          stroke-width="2"      
        ></path>
        <path
          d="M355.996 353.002c-6.25 0-7.046-1.479-32.86-18.689-7.353-4.902-9.34-14.836-4.438-22.188 4.902-7.353 14.836-9.339 22.188-4.438l10.688 7.125 23.125-34.687c4.901-7.353 14.837-9.339 22.188-4.438 7.353 4.902 9.34 14.836 4.438 22.188l-32 48c-3.085 4.625-8.159 7.127-13.329 7.127zM276.011 112h-136c-8.836 0-16-7.164-16-16s7.164-16 16-16h136c8.837 0 16 7.164 16 16s-7.164 16-16 16zM276.011 176h-136c-8.836 0-16-7.164-16-16s7.164-16 16-16h136c8.837 0 16 7.164 16 16s-7.164 16-16 16zM220.011 240h-80c-8.836 0-16-7.164-16-16s7.164-16 16-16h80c8.836 0 16 7.164 16 16s-7.164 16-16 16z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
          stroke-width="2"
        ></path>
      </g>
    </svg>
  );
}

export default License;
